module.exports = __webpack_public_path__ + "static/img/slogan.c5d8eba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/slogan.png
// module id = iMv4
// module chunks = 1